import { render, staticRenderFns } from "./SupplierBaseData.vue?vue&type=template&id=b4e1df0e"
import script from "./SupplierBaseData.vue?vue&type=script&lang=js"
export * from "./SupplierBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports